import { render, staticRenderFns } from "./CopyStakeWheelOfFortuneCampaignsTable.vue?vue&type=template&id=4826c964&scoped=true&lang=pug"
import script from "./CopyStakeWheelOfFortuneCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWheelOfFortuneCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWheelOfFortuneCampaignsTable.vue?vue&type=style&index=0&id=4826c964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826c964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMenu,VSelect,VSpacer,VTextField})
